import * as yup from 'yup';

const loginSchema = yup.object().shape({
	token: yup.string().required()
});

export default loginSchema;
